/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';

import { formValidator } from '../../../AppUtil/AppUtil';
import { toastOnConfirmChanges } from '../../../SweetAlertUtil/util';
import { commonStyleForEditPersonalInfo } from '../../Common/CommonStyle';
import BaseForm from './BaseForm';
import { hot } from 'react-hot-loader';

const PATTERN = window.AppConfig.REGULAR_EXPRESSION;

class EditProfile extends React.Component {
	constructor(props) {
		super(props);
		this.inputLabel = React.createRef();
		this.state = {
			_disableSaveButton: true,
			_editNameInfo: {
				firstName: {
					value: this.props.user.first_name || '',
					placeholder: 'label.first_name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_first_name'
						},
						pattern: {
							value: PATTERN.NAME,
							errorMsg: 'error_message.invalid_name'
						}
					},
					error_text: ''
				},
				lastName: {
					value: this.props.user.last_name || '',
					placeholder: 'label.last_name',
					isValid: false,
					isTouched: false,
					validationRules: {
						isRequired: {
							value: true,
							errorMsg: 'error_message.required_last_name'
						},
						pattern: {
							value: PATTERN.NAME,
							errorMsg: 'error_message.invalid_name'
						}
					},
					error_text: ''
				}
			}
		};
	}

	handelInputChange = e => {
		this.setState({
			_disableSaveButton: false
		});
		const name = e.target.name;
		const value = e.target.value;
		const editNameInfo = {
			...this.state._editNameInfo
		};
		const updatedFormElement = {
			...editNameInfo[name]
		};
		updatedFormElement.value = value;
		updatedFormElement.isValid = true;
		updatedFormElement.error_text = '';
		editNameInfo[name] = updatedFormElement;
		this.setState({
			_editNameInfo: editNameInfo
		});
	};

	onSubmitHandler = async e => {
		e.preventDefault();
		if (!this.formValidator()) {
			return false;
		}
		const editProfileForm = {
			...this.state._editNameInfo
		};
		const user = {
			first_name: editProfileForm.firstName.value,
			last_name: editProfileForm.lastName.value
		};
		toastOnConfirmChanges(this.props.onSubmit, user, this.props.closeProfileScreen);
	};

	formValidator = () => {
		const form = {
			...this.state._editNameInfo
		};
		const [updatedForm, isFormValid] = formValidator(form);
		this.setState({
			_editNameInfo: updatedForm
		});
		return isFormValid;
	};

	render() {
		const { classes } = this.props;
		const { t } = this.props;
		return (
			<BaseForm
				closeProfileScreen={this.props.closeProfileScreen}
				disabled={this.state._disableSaveButton}
				isLoading={this.props.isLoading}
				onSubmitHandler={this.onSubmitHandler}>
				<Grid alignItems="center" item justify="center" sm={12} xs={12}>
					<Typography component="h1" variant="h5">
						{t('profile.edit_name_details')}
					</Typography>
				</Grid>
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<TextField
						autoComplete="firstName"
						autoFocus
						className={classes.displayFlex}
						error={
							!this.state._editNameInfo.firstName.isValid && this.state._editNameInfo.firstName.isTouched
						}
						fullWidth
						helperText={
							!this.state._editNameInfo.firstName.isValid && this.state._editNameInfo.firstName.isTouched
								? t(this.state._editNameInfo.firstName.error_text)
								: ''
						}
						id="firstName"
						label={t(this.state._editNameInfo.firstName.placeholder)}
						margin="normal"
						name="firstName"
						onChange={this.handelInputChange}
						required
						value={this.state._editNameInfo.firstName.value}
						variant="outlined"
					/>
				</Grid>
				<Grid alignItems="center" item justify="center" sm={8} xs={12}>
					<TextField
						autoComplete="lastName"
						className={classes.displayFlex}
						error={
							!this.state._editNameInfo.lastName.isValid && this.state._editNameInfo.lastName.isTouched
						}
						fullWidth
						helperText={
							!this.state._editNameInfo.lastName.isValid && this.state._editNameInfo.lastName.isTouched
								? t(this.state._editNameInfo.lastName.error_text)
								: ''
						}
						id="lastName"
						label={t(this.state._editNameInfo.lastName.placeholder)}
						margin="normal"
						name="lastName"
						onChange={this.handelInputChange}
						required
						value={this.state._editNameInfo.lastName.value}
						variant="outlined"
					/>
				</Grid>
			</BaseForm>
		);
	}
}

export default hot(module)(withStyles(commonStyleForEditPersonalInfo)(withTranslation()(EditProfile)));
